import styled from 'styled-components'

import { mq, pxToRem, sizes } from '../../theme'
import BlockTitle from '../BlockTitle'
import Illustration from '../Illustration'
import RichText from '../RichText'
import ActionButton from '../ActionButton'
import Slider from '../Slider'
import { Nav } from '../Slider/styled'

export const Container = styled.section`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(56)};
  &:not(:first-child) {
    margin-block-start: var(--g_spacing__blocks);
  }
  @media ${mq(sizes.desktop)} {
    gap: ${pxToRem(144)};
  }
`
export const Wrapper = styled.div`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(32)};
  overflow: hidden;
  @media ${mq(sizes.desktop)} {
    gap: ${pxToRem(56)};
  }
`
export const _Slider = styled(Slider)`
  padding-inline: ${pxToRem(16)};
  & .keen-slider[data-keen-slider-disabled],
  & .keen-slider:not([data-keen-slider-disabled]) {
    overflow: visible;
  }
  @media ${mq(sizes.desktop)} {
    padding-inline: ${pxToRem(32)};
    & ${Nav} {
      position: absolute;
      inset-block-start: calc(100% + ${pxToRem(56)});
    }
  }
`
export const _BlockTitle = styled(BlockTitle)`
  width: 100%;
  max-width: calc(100% - ${pxToRem(16)} * 2);
  margin-inline: auto;
  @media ${mq(sizes.desktop)} {
    max-width: calc(100% - ${pxToRem(32)} * 2);
  }
`
export const _Illustration = styled(Illustration)`
  height: 100%;
  & img {
    display: block;
    height: 100%;
    object-fit: cover;
  }
  @media ${mq(sizes.desktop)} {
    aspect-ratio: auto;
    height: ${pxToRem(600)};
    width: auto;
    object-fit: none;
  }
`
export const Content = styled.div`
  ${({ theme }) => theme.textStyles.m375_body}
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(32)};
  width: 100%;
  max-width: min(${pxToRem(448)}, calc(100% - ${pxToRem(16)} * 2));
  margin-inline: auto;
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.d1440_body}
    max-width: max(${pxToRem(448)}, 30vw);
  }
`
export const _RichText = styled(RichText)``
export const _ActionButton = styled(ActionButton)``
